// extracted by mini-css-extract-plugin
export default {"privacy":"Screw_privacy__9oQ2n","listLink":"Screw_listLink__B3TCd"};